import Modal from "react-responsive-modal";
import { PurpleButton } from "../Buttons/PurpleButton";
import { BlackButton } from "../Buttons/BlackButton";

export const ProfileRequiredModal = ({ isOpen, onClose, onCreateProfile, action = "send messages" }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      center
             classNames={{
         modal: "w-[400px] rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]",
         overlay: "z-[9999999]",
         modalContainer: "z-[9999999]",
       }}
       styles={{
         modal: {
           zIndex: 9999999,
         },
         overlay: {
           zIndex: 9999999,
         },
       }}
    >
      <div className="p-[20px] text-center space-y-[20px]">
        <div className="text-[24px] font-semibold">Profile Required</div>
        <div className="text-[16px] text-[#666666]">
          You need to complete your profile before you can {action}. 
          This helps ensure trust and safety for all users.
        </div>
        <div className="flex gap-[10px]">
          <BlackButton 
            text="Cancel" 
            onClick={onClose} 
          />
          <PurpleButton 
            text="Create Profile" 
            onClick={onCreateProfile} 
          />
        </div>
      </div>
    </Modal>
  );
};